import { mapGetters } from 'vuex';

import { FavoriteSelectBookMixin } from '@/mixins/Bookmark/FavoriteSelectBook';
import { FavoriteSelectCourseMixin } from '@/mixins/Bookmark/FavoriteSelectCourse';

export default {
  name: 'SelectCourseMenu',

  mixins: [FavoriteSelectBookMixin, FavoriteSelectCourseMixin],

  computed: {
    ...mapGetters('Mixins/Bookmark', {
      mg_favoriteTree: 'favoriteTree',
      mg_selectedCourseName: 'selectedCourseName',
    }),
  },
};
